import * as Actions from 'store/actions/app/supplier_orders.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_supplier_orders: false,
  supplier_orders: [],
  total_supplier_orders: 0,

  saving_supplier_order: false,
  saved_supplier_order: false,
  saved_supplier_order_data: null,

  finishing_supplier_order: false,
  finished_supplier_order: false,

  accepting_supplier_order_ids: [],
  accepted_supplier_order_ids: [],

  voiding_supplier_order_ids: [],
  voided_supplier_order_ids: [],
}

export default function supplierOrdersReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.GET_SUPPLIER_ORDERS: {
      return {
        ...state,
        loading_supplier_orders: action.payload.loading ?? state.loading_supplier_orders,
        supplier_orders: action.payload.items ?? state.supplier_orders,
        total_supplier_orders: action.payload.total ?? state.total_supplier_orders,
      }
    }
    case Actions.SAVE_SUPPLIER_ORDER: {
      return {
        ...state,
        saving_supplier_order: action.payload.saving ?? state.saving_supplier_order,
        saved_supplier_order: action.payload.saved ?? false,
        saved_supplier_order_data: action.payload.data ?? null,
        supplier_orders: action.payload.data
          ? addOrUpdateObjectInArray(state.supplier_orders, action.payload.data, 'orden_proveedor_id', true)
          : state.supplier_orders,
      }
    }
    case Actions.FINISH_SUPPLIER_ORDER: {
      return {
        ...state,
        finishing_supplier_order: action.payload.finishing ?? state.finishing_supplier_order,
        finished_supplier_order: action.payload.finished ?? false,
        supplier_orders: action.payload.data
          ? addOrUpdateObjectInArray(state.supplier_orders, action.payload.data, 'orden_proveedor_id')
          : state.supplier_orders,
      }
    }
    case Actions.ACCEPT_SUPPLIER_ORDER: {
      return {
        ...state,
        accepting_supplier_order_ids: toggleIdInArray(state.accepting_supplier_order_ids, action.payload.accepting_id),
        accepted_supplier_order_ids: toggleIdInArray(state.accepted_supplier_order_ids, action.payload.accepted_id),
        supplier_orders: action.payload.data
          ? addOrUpdateObjectInArray(state.supplier_orders, action.payload.data, 'orden_proveedor_id')
          : state.supplier_orders,
      }
    }
    case Actions.VOID_SUPPLIER_ORDER: {
      return {
        ...state,
        voiding_supplier_order_ids: toggleIdInArray(state.voiding_supplier_order_ids, action.payload.voiding_id),
        voided_supplier_order_ids: toggleIdInArray(state.voided_supplier_order_ids, action.payload.voided_id),
        supplier_orders: action.payload.data
          ? addOrUpdateObjectInArray(state.supplier_orders, action.payload.data, 'orden_proveedor_id')
          : state.supplier_orders,
      }
    }
    default: {
      return state
    }
  }
}
